import * as types from '../actions/action-types';

export function getAssetsSuccess(assets) {
    return {
        type: types.GET_ASSETS_SUCCESS,
        assets
    };
}

export function refillBuffer(assets) {
    return {
        type: types.REFILL_BUFFER,
        assets
    };
}

export function getAssetsFromBuffer() {
    return {
        type: types.GET_ASSETS_FROM_BUFFER
    };
}

export function addUploadingAssets(files) {
    return {
        type: types.ADD_UPLOADING_ASSETS,
        files
    };
}

export function uploadAssetDone(tempUUID, asset) {
    return {
        type: types.UPLOAD_ASSET_DONE,
        assetId: tempUUID,
        asset
    };
}

export function assetError(assetId, errorCode, errorMessage) {
    return {
        type: types.ASSET_ERROR,
        assetId,
        errorCode,
        errorMessage
    };
}

export function assetProgress(assetId, progress, permanentUUID) {
    return {
        type: types.ASSET_UPDATE_PROGRESS,
        assetId,
        progress,
        permanentUUID
    };
}

export function assetPercentComplete(assetId, percentComplete) {
    return {
        type: types.ASSET_PERCENT_COMPLETE,
        assetId,
        percentComplete
    };
}

export function getAssetMetaData(assetId, newUUID, uploadId) {
    return {
        type: types.GET_ASSET_METADATA,
        assetId,
        newUUID,
        uploadId
    };
}

export function deleteAsset(assetId) {
    return {
        type: types.DELETE_ASSET_SUCCESS,
        assetId
    };
}

export function clearAssets() {
    return {
        type: types.CLEAR_ASSETS
    };
}